import * as type from "./type";

const initialState = {
  list: [],
  totalRecords: 0,
  totalPages: 0,
  loading: false,
};

const VendorMembersReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.GET_VENDOR_MEMBERS_REQUEST:
      return { ...state, loading: true };
    case type.GET_VENDOR_MEMBERS_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.payload?.list || [],
        totalRecords: action.payload?.totalRecords || 0,
        totalPages: action.payload?.totalPages || 0,
      };
    case type.GET_VENDOR_MEMBERS_FAILURE:
      return { ...state, loading: false, list: [], totalRecords: 0, totalPages: 0 };

    default:
      return state;
  }
};

export default VendorMembersReducer;
